/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { getTheme, FontSizes, FontWeights } from "office-ui-fabric-react";
import styled from "styled-components";

const theme = getTheme();

/**
 * Styles for result counts text
 */
export const ResultCount = styled.p`
  font-size: ${FontSizes.size14};
  font-weight: ${FontWeights.regular};
  color: ${theme.palette.black};
  text-align: right;
  line-height: 20px;
  margin-top: 10px;
`;
